// extracted by mini-css-extract-plugin
export var customPlayButton = "WidenVideoPlayer-module--custom-play-button--41598";
export var customPlayButtonIcon = "WidenVideoPlayer-module--custom-play-button-icon--6a1d3";
export var playerWrapper = "WidenVideoPlayer-module--player-wrapper--57a78";
export var reactPlayer = "WidenVideoPlayer-module--react-player--558b2";